import { chatsActions } from '@sv-support-sdk/store';

import { chatsActions as chatsActionsSelectors } from '../slices/chats';
import { TThunk } from '..';
import { userAuthorizedSelector } from '../selectors/user';

export const onChatClose = (): TThunk => (dispatch, getState) => {
  const state = getState();

  const isAuthorized = userAuthorizedSelector(state);

  const params = new URLSearchParams(document.location.search);
  const supportHistoryType = params.get('t');

  if (supportHistoryType === 'chats' && isAuthorized) {
    dispatch(chatsActions.getChats());
  }
};

export default {
  ...chatsActionsSelectors,
  ...chatsActions,
};
